import React, { memo, useEffect, useState, useRef } from 'react';
import cn from 'classnames';
import { toast } from 'react-toastify';
import HTToastContainer from 'HTKit/Toast/HTToastContainer';
import { TOAST_CONTAINER_ID } from 'HTKit/Toast/constants';
import { PINNED_CONTAINER_ID, PINNED_FOOTER_ID } from './constants';
import styles from './styles.scss';

const COUNTER = 8;
const TIME_INTERVAL = 500;

const PinnedContainer = () => {
  const [footerHeight, setFooterHeight] = useState(0);
  const footerRef = useRef();
  const intervalID = useRef();
  const counter = useRef(COUNTER);

  const clearFooterCheckInterval = () => {
    clearInterval(intervalID.current);
    intervalID.current = null;
  };

  /**
    Since toasts can be called in sagas, there's a chance that the page will not
    have rendered the button footer when the toast is called. The following
    will check the height of the footer in intervals.
  */
  const checkPinnedFooterHeight = () => {
    if (intervalID.current) {
      counter.current = COUNTER;
    } else {
      intervalID.current = setInterval(() => {
        setFooterHeight(footerRef.current.getBoundingClientRect().height);
        if (!counter.current) {
          clearFooterCheckInterval();
          counter.current = COUNTER;
        } else {
          counter.current -= 1;
        }
      }, TIME_INTERVAL);
    }
  };

  useEffect(() => {
    const unsubscribe = toast.onChange((_, containerId) => {
      if (containerId === TOAST_CONTAINER_ID && footerRef.current) {
        checkPinnedFooterHeight();
      }
    });

    return () => {
      unsubscribe();
      clearFooterCheckInterval();
    };
  }, []);

  return (
    <>
      <HTToastContainer className="site-v2" style={{ bottom: `${footerHeight}px` }} />
      <div className={cn('site-v2', styles.pinnedFooter)} id={PINNED_CONTAINER_ID}>
        <div id={PINNED_FOOTER_ID} ref={footerRef} />
      </div>
    </>
  );
};

export default memo(PinnedContainer);
